import request from '../utils/request'

// 管理员登录
export function login(data) {
  return request({ url: '/api/admin/login', method: 'post', data })
}

// 获取图形验证码
export function getCaptcha() {
  return request({ url: '/api/admin/captcha', method: 'get' })
}

// 用户管理
export function getUserList(params) {
  return request({ url: '/api/admin/user/list', method: 'get', params })
}
export function toggleUserStatus(userId) {
  return request({ url: `/api/admin/user/toggleStatus/${userId}`, method: 'put' })
}
export function getUserDetail(userId) {
  return request({ url: `/api/admin/user/detail/${userId}`, method: 'get' })
}

// 频道管理
export function getChannelList(params) {
  return request({ url: '/api/admin/channel/list', method: 'get', params })
}
// 频道全量列表为低频变化的配置数据，模块级缓存避免多个页面（课程列表/课程编辑）反复请求。
// 首次调用发起请求并缓存结果，后续直接返回缓存；如需强制刷新可调用 getChannelsFresh。
let allChannelsCache = null
export function getAllChannels() {
  if (allChannelsCache) return Promise.resolve(allChannelsCache)
  return request({ url: '/api/admin/channel/all', method: 'get' }).then((res) => {
    allChannelsCache = res
    return res
  })
}
export function getChannelsFresh() {
  return request({ url: '/api/admin/channel/all', method: 'get' }).then((res) => {
    allChannelsCache = res
    return res
  })
}
// 频道树（多层级）
export function getChannelTree() {
  return request({ url: '/api/admin/channel/tree', method: 'get' })
}
export function createChannel(data) {
  return request({ url: '/api/admin/channel/create', method: 'post', data })
}
export function updateChannel(data) {
  return request({ url: '/api/admin/channel/update', method: 'put', data })
}
export function toggleChannelStatus(channelId) {
  return request({ url: `/api/admin/channel/toggleStatus/${channelId}`, method: 'put' })
}
export function deleteChannel(channelId) {
  return request({ url: `/api/admin/channel/delete/${channelId}`, method: 'delete' })
}

// 知识分类管理
export function getKnowledgeCategoryList(params) {
  return request({ url: '/api/admin/knowledge/category/list', method: 'get', params })
}
export function getAllKnowledgeCategories() {
  return request({ url: '/api/admin/knowledge/category/all', method: 'get' })
}
export function createKnowledgeCategory(data) {
  return request({ url: '/api/admin/knowledge/category/create', method: 'post', data })
}
export function updateKnowledgeCategory(data) {
  return request({ url: '/api/admin/knowledge/category/update', method: 'put', data })
}
export function toggleKnowledgeCategoryStatus(categoryId) {
  return request({ url: `/api/admin/knowledge/category/toggleStatus/${categoryId}`, method: 'put' })
}
export function deleteKnowledgeCategory(categoryId) {
  return request({ url: `/api/admin/knowledge/category/delete/${categoryId}`, method: 'delete' })
}

// 知识合辑管理
export function getKnowledgeCollectionList(params) {
  return request({ url: '/api/admin/knowledge/collection/list', method: 'get', params })
}
export function getAllKnowledgeCollections() {
  return request({ url: '/api/admin/knowledge/collection/all', method: 'get' })
}
export function createKnowledgeCollection(data) {
  return request({ url: '/api/admin/knowledge/collection/create', method: 'post', data })
}
export function updateKnowledgeCollection(data) {
  return request({ url: '/api/admin/knowledge/collection/update', method: 'put', data })
}
export function toggleKnowledgeCollectionStatus(collectionId) {
  return request({ url: `/api/admin/knowledge/collection/toggleStatus/${collectionId}`, method: 'put' })
}
export function deleteKnowledgeCollection(collectionId) {
  return request({ url: `/api/admin/knowledge/collection/delete/${collectionId}`, method: 'delete' })
}

// 知识管理
export function getKnowledgeList(params) {
  return request({ url: '/api/admin/knowledge/list', method: 'get', params })
}
export function getKnowledgeDetail(knowledgeId) {
  return request({ url: `/api/admin/knowledge/detail/${knowledgeId}`, method: 'get' })
}
export function createKnowledge(data) {
  return request({ url: '/api/admin/knowledge/create', method: 'post', data })
}
export function updateKnowledge(data) {
  return request({ url: '/api/admin/knowledge/update', method: 'put', data })
}
export function toggleKnowledgeStatus(knowledgeId) {
  return request({ url: `/api/admin/knowledge/toggleStatus/${knowledgeId}`, method: 'put' })
}
export function deleteKnowledge(knowledgeId) {
  return request({ url: `/api/admin/knowledge/delete/${knowledgeId}`, method: 'delete' })
}

// 推荐管理（C端推荐位配置）
export function getRecommendList(params) {
  return request({ url: '/api/admin/recommend/list', method: 'get', params })
}
export function saveRecommend(data) {
  return request({ url: '/api/admin/recommend/save', method: 'post', data })
}
export function deleteRecommend(id) {
  return request({ url: `/api/admin/recommend/delete/${id}`, method: 'delete' })
}

// 礼物管理
export function getGiftList(params) {
  return request({ url: '/api/admin/gift/list', method: 'get', params })
}
export function createGift(data) {
  return request({ url: '/api/admin/gift/create', method: 'post', data })
}
export function updateGift(data) {
  return request({ url: '/api/admin/gift/update', method: 'put', data })
}
export function deleteGift(giftId) {
  return request({ url: `/api/admin/gift/delete/${giftId}`, method: 'delete' })
}

// 课程管理
export function getCourseList(params) {
  return request({ url: '/api/admin/course/list', method: 'get', params })
}
export function createCourse(data) {
  return request({ url: '/api/admin/course/create', method: 'post', data })
}
export function updateCourse(data) {
  return request({ url: '/api/admin/course/update', method: 'put', data })
}
export function updateCourseShelf(courseId, shelfStatus) {
  return request({ url: `/api/admin/course/shelf/${courseId}`, method: 'post', params: { shelfStatus } })
}
export function getCourseDetail(courseId) {
  return request({ url: `/api/admin/course/detail/${courseId}`, method: 'get' })
}
export function deleteCourse(courseId) {
  return request({ url: `/api/admin/course/delete/${courseId}`, method: 'delete' })
}
export function getLessonList(courseId) {
  return request({ url: `/api/admin/course/lesson/list/${courseId}`, method: 'get' })
}
export function saveLesson(data) {
  return request({ url: '/api/admin/course/lesson/save', method: 'post', data })
}
export function deleteLesson(lessonId) {
  return request({ url: `/api/admin/course/lesson/delete/${lessonId}`, method: 'delete' })
}

// 录播课留言管理（管理端）
export function getMessageList(params) {
  return request({ url: '/api/admin/course/message/list', method: 'get', params })
}
export function getMessageThread(rootId) {
  return request({ url: `/api/admin/course/message/thread/${rootId}`, method: 'get' })
}
export function replyMessage(data) {
  return request({ url: '/api/admin/course/message/reply', method: 'post', data })
}
export function readMessage(rootId) {
  return request({ url: `/api/admin/course/message/read/${rootId}`, method: 'put' })
}
export function deleteMessage(id) {
  return request({ url: `/api/admin/course/message/delete/${id}`, method: 'delete' })
}
export function getMessageUnreadCount() {
  return request({ url: '/api/admin/course/message/unreadCount', method: 'get' })
}

export function getSubscribeList(params) {
  return request({ url: '/api/admin/course/subscribe/list', method: 'get', params })
}

export function getViewList(params) {
  return request({ url: '/api/admin/course/view/list', method: 'get', params })
}
export function getLessonStudyList(params) {
  return request({ url: '/api/admin/course/lesson/study/list', method: 'get', params })
}

// 录播课留言（客户端接口，页面由客户端实现）
export function clientCreateMessage(data) {
  return request({ url: '/api/client/course/message/create', method: 'post', data })
}
export function clientMessageThreads(params) {
  return request({ url: '/api/client/course/message/list', method: 'get', params })
}
export function clientMessageThread(rootId) {
  return request({ url: `/api/client/course/message/thread/${rootId}`, method: 'get' })
}

// 首页音频推荐（客户端接口，页面由客户端实现）：查询录播课中课件类型为音频的课时列表
export function clientAudioRecommend(params) {
  return request({ url: '/api/client/course/audio/recommend', method: 'get', params })
}

// 视频观看记录（客户端接口，页面由客户端实现）
export function clientReportVideoWatch(data) {
  return request({ url: '/api/client/video-watch/report', method: 'post', data })
}
export function clientRecentVideoWatch(params) {
  return request({ url: '/api/client/video-watch/recent', method: 'get', params })
}

// 直播间管理
export function getLiveRoomList(params) {
  return request({ url: '/api/admin/live-room/list', method: 'get', params })
}
export function startLive(courseId, roomName) {
  return request({ url: `/api/admin/live-room/start/${courseId}`, method: 'post', params: { roomName } })
}
export function stopLive(courseId) {
  return request({ url: `/api/admin/live-room/stop/${courseId}`, method: 'post' })
}
export function refreshReplay(courseId) {
  return request({ url: `/api/admin/live-room/replay/refresh/${courseId}`, method: 'post' })
}
export function getLiveRoomDetail(courseId) {
  return request({ url: `/api/admin/live-room/detail/${courseId}`, method: 'get' })
}
export function refreshViewerCount(courseId) {
  return request({ url: `/api/admin/live-room/viewer/refresh/${courseId}`, method: 'post' })
}
export function getBarrageList(params) {
  return request({ url: '/api/admin/live-room/barrage/list', method: 'get', params })
}
// 主播工作台：初始化数据
export function getHostWorkbench(courseId) {
  return request({ url: '/api/admin/host/workbench/' + courseId, method: 'get' })
}
// 主播工作台：主播下发弹幕
export function sendHostBarrage(data) {
  return request({ url: '/api/admin/host/barrage', method: 'post', data })
}
export function getRewardList(params) {
  return request({ url: '/api/admin/live-room/reward/list', method: 'get', params })
}
export function getSignInList(params) {
  return request({ url: '/api/admin/course/sign-in/list', method: 'get', params })
}
export function getSignInStat(courseId) {
  return request({ url: `/api/admin/course/sign-in/stat/${courseId}`, method: 'get' })
}

// 系统设置 - 会员
export function getMemberLevels() {
  return request({ url: '/api/admin/settings/member/levels', method: 'get' })
}
export function saveMemberLevel(data) {
  return request({ url: '/api/admin/settings/member/level/save', method: 'post', data })
}
export function deleteMemberLevel(levelId) {
  return request({ url: `/api/admin/settings/member/level/delete/${levelId}`, method: 'delete' })
}

// 系统设置 - 系统配置
export function getSysConfigs(configGroup) {
  return request({ url: '/api/admin/settings/system/list', method: 'get', params: { configGroup } })
}
export function saveSysConfig(data) {
  return request({ url: '/api/admin/settings/system/save', method: 'post', data })
}
export function batchSaveSysConfigs(data) {
  return request({ url: '/api/admin/settings/system/batchSave', method: 'post', data })
}
// 查询视频点播存储信息（实时阿里云接口）
export function getVodStorageInfo() {
  return request({ url: '/api/admin/settings/storage/info', method: 'get' })
}

// 日志管理
export function getLogList(params) {
  return request({ url: '/api/admin/log/list', method: 'get', params })
}

// ========== 测试工具 ==========

// 直播拉流：依据流名生成推/播流地址
export function testLiveStream(data) {
  return request({ url: '/api/admin/test/live/stream', method: 'post', data })
}
// 阿里云互动消息：创建群组
export function testCreateGroup(data) {
  return request({ url: '/api/admin/test/im/group', method: 'post', data })
}
// 阿里云互动消息：获取客户端登录凭证
export function testImToken(data) {
  return request({ url: '/api/admin/test/im/token', method: 'post', data })
}

// 文件上传
export function uploadFile(file, subDir = 'common') {
  const formData = new FormData()
  formData.append('file', file)
  formData.append('subDir', subDir)
  return request({ url: '/api/admin/file/upload', method: 'post', data: formData, headers: { 'Content-Type': 'multipart/form-data' } })
}

// 点播直传凭证（CreateUploadVideo）：后端下发 STS 临时凭证，前端用 ali-oss 分片并发直传到点播存储，不经过服务器
export function getVodDirectUploadAuth(fileName) {
  return request({ url: '/api/admin/file/vodDirectUploadAuth', method: 'get', params: { fileName } })
}
// 刷新点播直传凭证（RefreshUploadVideo）：大文件直传超过 STS 凭证有效期（默认 1 小时）时续传用
export function refreshVodDirectUploadAuth(videoId) {
  return request({ url: '/api/admin/file/vodDirectUploadAuth/refresh', method: 'get', params: { videoId } })
}

// ========== 权限体系 ==========

// 管理端菜单
export function getMenuTree() {
  return request({ url: '/api/admin/menu/tree', method: 'get' })
}
export function getMyMenuTree() {
  return request({ url: '/api/admin/menu/myTree', method: 'get' })
}
export function createMenu(data) {
  return request({ url: '/api/admin/menu/create', method: 'post', data })
}

// 首页统计
export function getDashboardStat() {
  return request({ url: '/api/admin/statistics/dashboard', method: 'get' })
}

// 系统看板
export function getSystemStat() {
  return request({ url: '/api/admin/statistics/system', method: 'get' })
}

// 同步视频转码模板组到阿里云点播
export function syncTranscodeGroup(data) {
  return request({ url: '/api/admin/settings/transcode-group/sync', method: 'post', data })
}
// 从阿里云查询转码模板组详情
export function getTranscodeGroup(templateGroupId) {
  return request({ url: `/api/admin/settings/transcode-group/${templateGroupId}`, method: 'get' })
}

// 视频：根据 videoId 获取播放地址（字段名 playAuth，值存放播放地址，供原生 video / hls.js 播放；判断上传状态）
export function getVideoPlayAuth(videoId) {
  return request({ url: '/api/admin/file/playAuth', method: 'get', params: { videoId } })
}

// 课程看板-直播
export function getLiveCourseStat() {
  return request({ url: '/api/admin/statistics/course/live', method: 'get' })
}

// 课程看板-录播
export function getRecordedCourseStat() {
  return request({ url: '/api/admin/statistics/course/recorded', method: 'get' })
}

// 课程看板-考试
export function getExamStat() {
  return request({ url: '/api/admin/statistics/course/exam', method: 'get' })
}
export function updateMenu(data) {
  return request({ url: '/api/admin/menu/update', method: 'put', data })
}
export function deleteMenu(id) {
  return request({ url: `/api/admin/menu/delete/${id}`, method: 'delete' })
}

// 客户端菜单/功能权限
export function getClientMenuTree() {
  return request({ url: '/api/admin/client-menu/tree', method: 'get' })
}
export function createClientMenu(data) {
  return request({ url: '/api/admin/client-menu/create', method: 'post', data })
}
export function updateClientMenu(data) {
  return request({ url: '/api/admin/client-menu/update', method: 'put', data })
}
export function deleteClientMenu(id) {
  return request({ url: `/api/admin/client-menu/delete/${id}`, method: 'delete' })
}

// 角色
export function getRoleList(params) {
  return request({ url: '/api/admin/role/list', method: 'get', params })
}
// roleType: 1-管理员角色 2-客户端角色
export function getAllRoles(params) {
  return request({ url: '/api/admin/role/all', method: 'get', params })
}
export function createRole(data) {
  return request({ url: '/api/admin/role/create', method: 'post', data })
}
export function updateRole(data) {
  return request({ url: '/api/admin/role/update', method: 'put', data })
}
export function deleteRole(roleId) {
  return request({ url: `/api/admin/role/delete/${roleId}`, method: 'delete' })
}
export function getRoleMenus(roleId) {
  return request({ url: `/api/admin/role/menus/${roleId}`, method: 'get' })
}

// 管理员
export function getAdminList(params) {
  return request({ url: '/api/admin/list', method: 'get', params })
}
export function createAdmin(data) {
  return request({ url: '/api/admin/create', method: 'post', data })
}
export function updateAdmin(data) {
  return request({ url: '/api/admin/update', method: 'put', data })
}
export function assignAdminRoles(data) {
  return request({ url: '/api/admin/assignRoles', method: 'post', data })
}
export function assignUserRoles(data) {
  return request({ url: '/api/admin/user/assignRoles', method: 'post', data })
}
export function deleteAdmin(adminId) {
  return request({ url: `/api/admin/delete/${adminId}`, method: 'delete' })
}
// 当前管理员个人资料（昵称/头像/密码）
export function getProfile() {
  return request({ url: '/api/admin/profile', method: 'get' })
}
export function updateProfile(data) {
  return request({ url: '/api/admin/profile/update', method: 'post', data })
}

// 账户管理
export function accountLevelList() {
  return request({ url: '/api/admin/account/level/list', method: 'get' })
}
export function accountLevelSave(data) {
  return request({ url: '/api/admin/account/level/save', method: 'post', data })
}
export function accountLevelDelete(levelId) {
  return request({ url: `/api/admin/account/level/delete/${levelId}`, method: 'delete' })
}
export function accountList(params) {
  return request({ url: '/api/admin/account/list', method: 'get', params })
}
export function accountAdjustCoin(data) {
  return request({ url: '/api/admin/account/adjustCoin', method: 'post', data })
}
export function accountUpdateLevel(data) {
  return request({ url: '/api/admin/account/updateLevel', method: 'post', data })
}
export function accountTransactionList(params) {
  return request({ url: '/api/admin/account/transaction/list', method: 'get', params })
}
export function accountUpgradeList(params) {
  return request({ url: '/api/admin/account/upgrade/list', method: 'get', params })
}
export function accountViewList(params) {
  return request({ url: '/api/admin/account/view/list', method: 'get', params })
}
export function accountAdjustPoints(data) {
  return request({ url: '/api/admin/account/adjustPoints', method: 'post', data })
}
export function accountPointsList(params) {
  return request({ url: '/api/admin/account/points/list', method: 'get', params })
}

// ========== 考试管理 ==========

// 题目管理
export function getQuestionList(params) {
  return request({ url: '/api/admin/exam/question/list', method: 'get', params })
}
export function createQuestion(data) {
  return request({ url: '/api/admin/exam/question/create', method: 'post', data })
}
export function updateQuestion(data) {
  return request({ url: '/api/admin/exam/question/update', method: 'put', data })
}
export function deleteQuestion(id) {
  return request({ url: `/api/admin/exam/question/delete/${id}`, method: 'delete' })
}
export function getQuestionDetail(id) {
  return request({ url: `/api/admin/exam/question/detail/${id}`, method: 'get' })
}
export function getCourseOptions(keyword) {
  return request({ url: '/api/admin/exam/question/course/options', method: 'get', params: { keyword } })
}
export function getStageOptions(courseId) {
  return request({ url: '/api/admin/exam/question/stage/options', method: 'get', params: { courseId } })
}
export function getFilterQuestions(params) {
  return request({ url: '/api/admin/exam/question/filter', method: 'get', params })
}

// 考试管理
export function getExamList(params) {
  return request({ url: '/api/admin/exam/list', method: 'get', params })
}
export function createExam(data) {
  return request({ url: '/api/admin/exam/create', method: 'post', data })
}
export function updateExam(data) {
  return request({ url: '/api/admin/exam/update', method: 'put', data })
}
export function deleteExam(id) {
  return request({ url: `/api/admin/exam/delete/${id}`, method: 'delete' })
}
export function getExamDetail(id) {
  return request({ url: `/api/admin/exam/detail/${id}`, method: 'get' })
}
export function getExamQuestions(params) {
  return request({ url: '/api/admin/exam/questions', method: 'get', params })
}
export function previewExam(data) {
  return request({ url: '/api/admin/exam/preview', method: 'post', data })
}

// 成绩查看
export function getRecordList(params) {
  return request({ url: '/api/admin/exam/record/list', method: 'get', params })
}
export function getRecordDetail(id) {
  return request({ url: `/api/admin/exam/record/detail/${id}`, method: 'get' })
}
// 成绩人工批改 / 重判（主要针对问答题）
export function gradeRecord(data) {
  return request({ url: '/api/admin/exam/record/grade', method: 'post', data })
}
// 成绩导出（CSV 下载）
export function exportRecord(params) {
  return request({ url: '/api/admin/exam/record/export', method: 'get', params, responseType: 'blob' })
}

